export function transferToBitsPerSec(durationMs: number, numBytes: number): number {
	const numBits: number = 8 * numBytes;
	const durationSecs: number = durationMs / 1000;

	return numBits / durationSecs;
}

export function bitsPerSecToBytesPerSec(value: number): number {
	return value / 8;
}
